import Ajax from "base/Ajax";
import CookieHelper from "base/CookieHelper";
import Message from "base/Message";
import AjaxConfirmModal from "modals/AjaxConfirmModal";
import AjaxForm, { EVENT_SUCCESS } from "webPage/AjaxForm";
import Page from "webPage/Page";

Page.register(new RegExp('^/customers/([0-9a-f]+)/projects/([0-9a-f]+)/domains/([0-9a-f]+)/?$'), ([customer_id, project_id, domain_id]) => {
    let form = new AjaxForm($(".js-domain-form"), ($form, formData) => {
        return Ajax.post("billing", "domains/" + (domain_id === "add" ? "" : domain_id), $.extend({
            customer: customer_id,
            project: project_id,
        }, formData));
    }, {
        selectors: {
            errorContainer: $(".js-message-holder"),
        },
    });

    form.on(EVENT_SUCCESS, (data) => {
        if (domain_id === "add") {
            CookieHelper.set('did-add-domain', data.id);
            window.location.href = data.links.view;
            // Keep loading
            return false;
        }

        // Update domain which will have been cleaned
        form.getFormElement().find("[name='domain-name']").val(data.domainName);

        form.getErrorContainer().html(Message.get_inline_message('The domain has been updated successfully', 'Domain updated', Message.SUCCESS));
    });

    $("body").on("click", ".js-delete-domain", () => {
        let modal = new AjaxConfirmModal("Are you sure you want to delete this domain?", undefined, async () => {
            await Ajax.delete("billing", "domains/" + domain_id);
        });
        modal.on("success", async () => {
            CookieHelper.set('did-delete-domain', project_id);
            window.location.href = "/customers/" + customer_id + "/projects/" + project_id + "/";
        });
        modal.show();

        return false;
    }).on("change", ".js-domain-cancelled", function () {
        let checked = $(this).is(":checked");

        $(this).closest('form').find(".js-control-field").prop("disabled", checked);
    });
});
